import { observable } from 'mobx';

export class MailchimpModel {
  @observable
  action = {
    artist: process.env.MAILCHIMP_ARTIST,
  };

  @observable
  launchReminder = {
    action: process.env.MAILCHIMP_LAUNCH_REMINDER_URL,
    hidden: process.env.MAILCHIMP_LAUNCH_REMINDER_HIDDEN
  };

  @observable
  email: string = '';

  @observable
  fields: MailchimpFields = {};
}

export type MailchimpFields = { [key: string]: string };